<template>
    <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">
        <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
            <el-col class="flex-box al-c" :span="4">
                <el-button type="primary" @click="initPage">查询</el-button>
                <el-button type="primary" @click="addFn">添加</el-button>
            </el-col>
        </Sift>

        <div class="table-con">
            <el-table class="w100 mt20 table" header-row-class-name="table-head"
                      row-class-name="cu-p" stripe :data="list" >
                <el-table-column align="center" label="序号" width="50px">
                    <template slot-scope="scope">
                        {{ paramSearch.current * paramSearch.size - paramSearch.size + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="name" label="信息导航名称"></el-table-column>
                <el-table-column align="center" prop="url" label="链接地址"></el-table-column>
                <el-table-column align="center" prop="createUser" label="创建人"></el-table-column>
                <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>

                <el-table-column align="center" prop="refuseIP" label="操作">
                    <template slot-scope="scope">
                        <div class="to-use">
                            <span class="info" @click="editFn(scope.row.id)">编辑</span>
                            <span class="danger" @click="deleteFn(scope.row.id)">删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="mt20 flex-box">
            <div class="flex-1"></div>
            <el-pagination background @size-change="changeSize"
                           @current-change="changePage"
                           :current-page="paramSearch.current"
                           :page-sizes="pageSizes"
                           :page-size="paramSearch.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total"
            ></el-pagination>
        </div>

        <!-- 详情、新增 -->
        <NavlinkDialog ref="NavlinkDialog" @saveSuccess="saveSuccess"/>

    </div>
</template>

<script>
    import Sift from "@/components/sift/Sift";
    import NavlinkDialog from "@/components/management/navlink/NavlinkDialog";
    import { getNavigationPage,getNavigationInfo, handleNavigationDelete} from '@/api/managementCenter/navlink';

    export default {
        name: "Navlink",
        components: {
            Sift,
            NavlinkDialog
        },
        props: [],
        data() {
            return {
                loading: false,
                siftData : [
                    {
                        type: "text",
                        key: "keywords",
                        label: "信息导航名称",
                        placeholder: "请输入导航名称",
                        default: ""
                    }
                ],
                list: [],
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10
                },
                total: 0
            };
        },
        computed: {},
        created() {},
        mounted() {
            this.getListFn();
        },
        methods: {
            // 获取查询列表
            getListFn () {
                this.loading = true;
                getNavigationPage(this.paramSearch).then(({data})=> {
                    this.loading = false;
                    if(data.code == 0){
                        this.list = data.data.records || []
                        this.total = data.data.total;
                    }
                })
                    .catch(() => {
                        this.loading = false;
                    });
            },

            // 添加
            addFn() {
                this.$refs.NavlinkDialog.dialogShow('add');
            },

            // 删除
            deleteFn (id) {
                this.$confirm( "是否确定删除?", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteHttp(id)

                }).catch(() => {
                    this.$message.info( "已取消删除" );

                });
            },
            deleteHttp(id){
                this.loading = true;
                // 删除接口
                handleNavigationDelete(id).then( ({data}) => {
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success("删除成功!" );
                        this.getListFn();
                    }else{
                        this.$message.warning( data.msg||"删除失败！" );
                    }
                }).catch(() => {
                    this.loading = false;
                    this.$message.error( "删除异常!" );
                });
            },
            // 详情
            editFn (id, name) {
                this.loading = true;
                getNavigationInfo(id).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0){

                        this.$refs.NavlinkDialog.dialogShow('edit',data.data);

                    }else{
                        this.$message.warning( data.msg||"获取导航链接信息失败！" );
                    }
                }).catch(err=>{
                    this.loading = false;
                })


            },

            // 默认页面数据
            initPage() {
                this.paramSearch={
                    ...this.paramSearch,
                    ...this.$refs.needSift.getValue(),
                    current:1
                }
                this.getListFn();
            },

            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getListFn();
            },
            saveSuccess(){
                this.getListFn();
            }
        },
        watch: {},
        filters: {}
    };
</script>

<style scoped  lang="less">
    @import "../../../assets/css/handleBtn.less";
    /deep/.el-table {
        width: 100%;
        .el-table__body-wrapper {
            max-height: calc(100vh - 300px);
            overflow-y: auto;

        }
    }
</style>
